/* eslint-disable */

const AG_GRID_LOCALE_PT = {
  // Set Filter
  selectAll: '(Selecionar Tudo)',
  selectAllSearchResults: '(Selecionar todos os resultados de busca)',
  searchOoo: 'Pesquisar...',
  blanks: '(Em branco)',
  noMatches: 'Sem resultados',

  // Number Filter & Text Filter
  filterOoo: 'Filtrar...',
  equals: 'Igual',
  notEqual: 'Diferente',
  blank: 'em branco',
  notBlank: 'Preenchido',
  empty: 'Escolha um',

  // Number Filter
  lessThan: 'Menor que',
  greaterThan: 'Maior que',
  lessThanOrEqual: 'Menor ou igual que',
  greaterThanOrEqual: 'Maior ou igual que',
  inRange: 'No intervalo',
  inRangeStart: 'de',
  inRangeEnd: 'para',

  // Text Filter
  contains: 'Contém',
  notContains: 'Não contém',
  startsWith: 'Começa com',
  endsWith: 'Termina com',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'E',
  orCondition: 'OU',

  // Filter Buttons
  applyFilter: 'Aplicar',
  resetFilter: 'Resetar',
  clearFilter: 'Limpar',
  cancelFilter: 'Cancelar',

  // Filter Titles
  textFilter: 'Filtro de texto',
  numberFilter: 'Filtro de número',
  dateFilter: 'Filtro de data',
  setFilter: 'Definir filtro',

  // Side Bar
  columns: 'Columas',
  filters: 'Filtros',

  // columns tool panel
  pivotMode: 'Modo Pivo',
  groups: 'Grupo de linhas',
  rowGroupColumnsEmptyMessage: 'Arraste aqui para definir o grupo de linhas',
  values: 'Valores',
  valueColumnsEmptyMessage: 'Arraste aqui para agregar',
  pivots: 'Rótulo das colunas',
  pivotColumnsEmptyMessage: 'Arraste aqui para definir o grupo de rótulos',

  // Header of the Default Group Column
  group: 'Grupo',

  // Row Drag
  rowDragRows: 'Linhas',

  // Other
  loadingOoo: 'Carregando...',
  noRowsToShow: 'Nenhum resultado para mostrar',
  enabled: 'Habilitado',

  // Menu
  pinColumn: 'Fixar columa',
  pinLeft: 'Fixar à esquerda',
  pinRight: 'Fixar à direita',
  noPin: 'Desafixar',
  valueAggregation: 'Agregar valor',
  autosizeThiscolumn: 'Tamanho automático da coluna',
  autosizeAllColumns: 'Tamanho automático de todas as colunas',
  groupBy: 'Agrupar pot',
  ungroupBy: 'Desagrupar por',
  addToValues: 'Adicionar ${variable} aos valores',
  removeFromValues: 'Remover ${variable} dos valores',
  addToLabels: 'Adicionar ${variable} aos rótulos',
  removeFromLabels: 'Remover ${variable} dos rótulos',
  resetColumns: 'Redefinir colunas',
  expandAll: 'Expandir tudo',
  collapseAll: 'Fechar tudo',
  copy: 'Copiar',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copiar com cabeçalho',
  copyWithHeaderGroups: 'Copiar com grupo de cabeçalhos',
  paste: 'Colar',
  ctrlV: 'Ctrl+V',
  export: 'Exportar',
  csvExport: 'Exportar para CSV',
  excelExport: 'Exportar para Excel',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Média',
  filteredRows: 'Filtrado',
  selectedRows: 'Selecionado',
  totalRows: 'Total',
  totalAndFilteredRows: 'resultados',
  more: 'Mais',
  to: 'até',
  of: 'de',
  page: 'Página',
  nextPage: 'Próxima ',
  lastPage: 'Última',
  firstPage: 'Primeira',
  previousPage: 'Anterior',

  // Pivoting
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  combinationChart: 'Combination',
  columnLineCombo: 'Column & Line',
  AreaColumnCombo: 'Area & Column',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  combinationGroup: 'Combination',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  columnLineComboTooltip: 'Column & Line',
  areaColumnComboTooltip: 'Area & Column',
  customComboTooltip: 'Custom Combination',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',
  seriesChartType: 'Series Chart Type',
  seriesType: 'Series Type',
  secondaryAxis: 'Secondary Axis',

  // ARIA
  ariaHidden: 'hidden',
  ariaVisible: 'visible',
  ariaChecked: 'checked',
  ariaUnchecked: 'unchecked',
  ariaIndeterminate: 'indeterminate',
  ariaDefaultListName: 'List',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterList: 'Filter List',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumn: 'Column',
  ariaColumnList: 'Column List',
  ariaColumnGroup: 'Column Group',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaToggleVisibility: 'Press SPACE to toggle visibility',
  ariaSearch: 'Search',
  ariaSearchFilterValues: 'Search filter values',

  ariaRowGroupDropZonePanelLabel: 'Row Groups',
  ariaValuesDropZonePanelLabel: 'Values',
  ariaPivotDropZonePanelLabel: 'Column Labels',
  ariaDropZoneColumnComponentDescription: 'Press DELETE to remove',
  ariaDropZoneColumnValueItemDescription: 'Press ENTER to change the aggregation type',

  // ARIA Labels for Dialogs
  ariaLabelColumnMenu: 'Menu de coluna',
  ariaLabelCellEditor: 'Editor de célula',
  ariaLabelDialog: 'Diálogo',
  ariaLabelSelectField: 'Selecionar Campo',
  ariaLabelTooltip: 'Tooltip',
  ariaLabelContextMenu: 'Menu de contexto',
  ariaLabelSubMenu: 'SubMenu',
  ariaLabelAggregationFunction: 'Função de agregação',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: '.',
  decimalSeparator: ',',

};

export default AG_GRID_LOCALE_PT;
